import Axios from "axios";
var SupplierService = (function () {
    function SupplierService() {
    }
    SupplierService.prototype.getListUpper = function (params) {
        return Axios.post("/supplierclientapi/supplierupper/list_upper", params);
    };
    SupplierService.prototype.getAccountDatetype = function () {
        return Axios.get("/supplierclientapi/supplierupper/get_account_datetype");
    };
    SupplierService.prototype.getTaxTicketType = function () {
        return Axios.get("/supplierclientapi/supplierupper/get_tax_tickettype");
    };
    SupplierService.prototype.getCategory = function (params) {
        return Axios.get("/supplierclientapi/supplierupper/get_category", { params: params });
    };
    SupplierService.prototype.saveCategory = function (params) {
        return Axios.post("/supplierclientapi/supplierupper/save_category", params);
    };
    SupplierService.prototype.delCategory = function (params) {
        return Axios.post("/supplierclientapi/supplierupper/del_category", params);
    };
    SupplierService.prototype.saveUpper = function (params) {
        return Axios.post("/supplierclientapi/supplierupper/save_upper", params);
    };
    SupplierService.prototype.deatilUpper = function (params) {
        return Axios.post("/supplierclientapi/supplierupper/detail_upper", params);
    };
    SupplierService.prototype.disEnable = function (params) {
        return Axios.post("/supplierclientapi/supplierupper/batch_save", params);
    };
    SupplierService.prototype.getOrganList = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    SupplierService.prototype.getPinyin = function (params) {
        return Axios.get("basicapi/getpinyin", { params: params });
    };
    SupplierService.prototype.getSupplierupperOptions = function (params) {
        return Axios.get("supplierclientapi/supplierupper/get_options", { params: params });
    };
    SupplierService.createInstance = function () {
        SupplierService.getInstance();
    };
    SupplierService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return SupplierService;
}());
export default SupplierService;
